<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>

    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Buat {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Buat</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="row">
              <div class="col-md-5">
                <div class="form-group">
                  <label>Supplier <span class="text-danger">*</span></label>
                  <v-select
                    v-model="form.pmb_supplier_id"
                    :options="supplierOptions"
                    label="label"
                    :reduce="(opt) => opt.value"
                    placeholder="Pilih supplier..."
                  ></v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Tanggal Pembelian <span class="text-danger">*</span></label>
                  <date-picker
                    v-model="form.pmb_date"
                    format="YYYY-MM-DD"
                    value-type="format"
                    :input-class="'form-control'"
                    style="width: 100%"
                    placeholder="Pilih tanggal..."
                  ></date-picker>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>No. Pembelian</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.pmb_no"
                    placeholder="Diisi otomatis jika kosong"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Catatan</label>
                  <textarea
                    class="form-control"
                    v-model="form.pmb_notes"
                    rows="2"
                    placeholder="Catatan pembelian..."
                  ></textarea>
                </div>
              </div>
            </div>

            <hr />

            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="font-size-15 mb-0">Detail Produk</h5>
              <button type="button" class="btn btn-secondary btn-sm" @click="addItem">
                <i class="mdi mdi-plus"></i> Tambah Produk
              </button>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-nowrap">
                <thead class="thead-light">
                  <tr>
                    <th style="width:33%">Produk</th>
                    <th style="width:10%">Qty</th>
                    <th style="width:22%">Harga Beli</th>
                    <th style="width:22%">Subtotal</th>
                    <th style="width:5%" class="text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td>
                      <v-select
                        v-model="item.product"
                        :options="item.productOptions"
                        label="label"
                        placeholder="Cari nama / kode produk..."
                        @search="(q) => searchProduct(q, index)"
                        @input="onProductSelected(index)"
                        :filterable="false"
                      ></v-select>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="item.qty"
                        min="1"
                        @input="calcSubtotal(index)"
                      />
                    </td>
                    <td>
                      <currency-input class="form-control" v-model="item.price" @input="calcSubtotal(index)" />
                      <small v-if="item.prd_price_original" class="text-muted">
                        Asli: Rp {{ numberFormat(item.prd_price_original) }}
                      </small>
                    </td>
                    <td>
                      <currency-input class="form-control" v-model="item.subtotal" @input="calcPrice(index)" />
                    </td>
                    <td class="align-middle text-center">
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="removeItem(index)"
                        :disabled="items.length === 1"
                      >
                        <i class="mdi mdi-delete"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row justify-content-end mt-2">
              <div class="col-md-4">
                <table class="table table-sm mb-0">
                  <tr>
                    <th>Total Pembelian</th>
                    <td class="text-right">
                      <strong>Rp {{ numberFormat(grandTotal) }}</strong>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <hr />
            <div class="d-flex justify-content-end">
              <router-link :to="{ name: table_module }" class="btn btn-secondary mr-2">
                Batal
              </router-link>
              <button type="button" class="btn btn-primary" @click="save" :disabled="isSaving">
                <i v-if="isSaving" class="mdi mdi-loading mdi-spin mr-1"></i>
                {{ isSaving ? "Menyimpan..." : "Simpan" }}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      isSaving: false,
      module: "Pembelian Produk",
      table_module: "pembelian_produk",
      supplierOptions: [],
      form: {
        pmb_supplier_id: null,
        pmb_date: null,
        pmb_no: "",
        pmb_notes: "",
      },
      items: [
        { product: null, productOptions: [], qty: 1, price: 0, subtotal: 0, prd_price_original: 0 },
      ],
    };
  },
  computed: {
    grandTotal() {
      return this.items.reduce((sum, item) => sum + (item.subtotal || 0), 0);
    },
  },
  mounted() {
    this.fetchSuppliers();
  },
  methods: {
    fetchSuppliers() {
      this.axios.get("/dropdown/list/dd_supplier").then((response) => {
        this.supplierOptions = response.data.data || [];
      });
    },
    searchProduct(query, index) {
      if (query.length < 2) return;
      this.axios
        .get("/dropdown/autocomplete/products", {
          params: { "search[prd_name]": query },
        })
        .then((response) => {
          this.items[index].productOptions = response.data.data || [];
        });
    },
    onProductSelected(index) {
      const product = this.items[index].product;
      if (product) {
        this.items[index].price = product.prd_price || 0;
        this.items[index].prd_price_original = product.prd_price || 0;
        this.calcSubtotal(index);
      }
    },
    calcSubtotal(index) {
      const item = this.items[index];
      item.subtotal = (item.qty || 0) * (item.price || 0);
    },
    calcPrice(index) {
      const item = this.items[index];
      const qty = item.qty || 1;
      item.price = qty > 0 ? Math.round((item.subtotal || 0) / qty) : 0;
    },
    addItem() {
      this.items.push({ product: null, productOptions: [], qty: 1, price: 0, subtotal: 0, prd_price_original: 0 });
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    numberFormat(value) {
      return this.$root.numberWithCommas(value || 0);
    },
    validate() {
      if (!this.form.pmb_supplier_id) {
        this.$toast.error("Supplier wajib dipilih");
        return false;
      }
      if (!this.form.pmb_date) {
        this.$toast.error("Tanggal pembelian wajib diisi");
        return false;
      }
      const hasProduct = this.items.some((item) => item.product !== null);
      if (!hasProduct) {
        this.$toast.error("Minimal satu produk harus dipilih");
        return false;
      }
      return true;
    },
    save() {
      if (!this.validate()) return;

      this.isSaving = true;
      const payload = {
        ...this.form,
        pmb_total: this.grandTotal,
        items: this.items
          .filter((item) => item.product !== null)
          .map((item) => ({
            prd_id: item.product.value,
            pmbd_qty: item.qty,
            pmbd_price: item.price,
            pmbd_subtotal: item.subtotal,
          })),
      };

      this.axios
        .post("/" + this.table_module + "/save", payload)
        .then((response) => {
          if (response.data.status == 200) {
            this.$toast("Pembelian berhasil disimpan");
            this.$router.push({ name: this.table_module });
          } else {
            this.$toast.error(response.data.message || "Gagal menyimpan data");
          }
        })
        .catch(() => {
          this.$toast.error("Terjadi kesalahan, coba lagi");
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>
